import './component/prems-premium-item-info-banner';
import './component/prems-premium-item-statistic-hint';
import './component/prems-premium-item-iap-list';

import './page/prems-premium-item';

Shopware.Module.register('prems-premium-item', {
    type: 'plugin',
    name: 'Premium Item',
    title: 'Premium Item system module',
    description: 'Module for premium item administration',
    color: '#62ff80',
    entity: 'prems_premium_item',

    routes: {
        index: {
            path: 'index',
            component: 'prems-premium-item',
        },
    },

    navigation: [{
        path: 'prems.premium.item.index',
        label: 'prems-premium-item.menu-item.main',
        color: '#57D9A3',
        parent: 'sw-catalogue',
        position: 30
    }],
});